import { render, staticRenderFns } from "./FileLoader.vue?vue&type=template&id=045d5efa&lang=pug"
import script from "./FileLoader.vue?vue&type=script&lang=js"
export * from "./FileLoader.vue?vue&type=script&lang=js"
import style0 from "./FileLoader.vue?vue&type=style&index=0&id=045d5efa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports